import { Singup, Signin, ForgotPassword, ResetPassword, Main } from './components'

const children = [{
  name: 'auth.signin',
  path: 'signin',
  component: Signin,
  meta: { requiresAuth: false }
}, {
  name: 'auth.singup',
  path: 'singup',
  component: Singup,
  meta: { requiresAuth: false }
}, {
  name: 'auth.forgotpassword',
  path: 'forgotpassword',
  component: ForgotPassword,
  meta: { requiresAuth: false }
}, {
  name: 'auth.reset',
  path: 'reset/:token',
  props: true,
  component: ResetPassword,
  meta: { requiresAuth: false }
}]

export default [{
  children,
  name: 'auth',
  path: '/auth',
  component: Main,
  redirect: { name: 'auth.signin' },
  meta: { requiresAuth: false }
}]



// WEBPACK FOOTER //
// ./src/app/auth/routes/index.js